import styles from './styles.module.scss';

import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import tick from '../../../../assets/media/icons/tick.svg';
import minus from '../../../../assets/media/icons/minus.svg';
import Button from '../Button';

const TYPE_CHECK = {
  tick: { type: 'tick', src: tick },
  minus: { type: 'minus', src: minus },
};

const CheckButton = ({
  checked = false,
  onSelect = () => {},
  small = false,
  disabled = false,
  type = TYPE_CHECK.tick.type,
  ...props
}) => {
  const [check, changeCheck] = useState(checked);

  const onCheck = () => {
    //changeCheck(!check);
    onSelect(!check);
  };
  useEffect(() => {
    changeCheck(checked);
  }, [checked]);

  return (
    <Button
      className={cn(styles.tick_block, small && styles.small_block, disabled && styles.cursor_disabled, props.styles)}
      style={props.style}
      onClick={!disabled ? () => onCheck() : () => {}}
    >
      {check && (
        <img
          src={TYPE_CHECK[type].src}
          alt=""
          className={cn(
            type === TYPE_CHECK.tick.type && (small ? styles.tick_img_small : styles.tick_img),
            type === TYPE_CHECK.minus.type && (small ? styles.minus_img_small : styles.minus_img),
          )}
        />
      )}
    </Button>
  );
};

export default CheckButton;
